/**
 * @description 灰度配置 grayConfig
 * @author xiehan
 * @date 2019/08/22
 */

import Logic from '../logic-base'
import ExportTable from '@/utils/exportTable'

const grayConfigBiz = new Logic()

grayConfigBiz.queryAllInfo = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.grayConfig.queryAllInfo,
    data: data
  })
}

grayConfigBiz.queryRuleDetail = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.grayConfig.queryRuleDetail,
    data: data
  })
}

grayConfigBiz.upsertAllInfo = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.grayConfig.upsertAllInfo,
    data: data
  })
}

grayConfigBiz.tagHisQuery = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.grayConfig.tagHisQuery,
    data: data
  })
}

grayConfigBiz.cutover = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.grayConfig.cutover,
    data: data
  })
}

grayConfigBiz.publish = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.grayConfig.publish,
    data: data
  })
}

grayConfigBiz.rollback = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.grayConfig.rollback,
    data: data
  })
}

grayConfigBiz.toend = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.grayConfig.toend,
    data: data
  })
}

grayConfigBiz.queryMonitor = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.grayConfig.queryMonitor,
    data: data
  })
}

grayConfigBiz.clean = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.grayConfig.clean,
    data: data
  })
}

/**
 * Created by xiehan on 2019/08/27.
 * 灰度配置导出key
 * @param fields 表头信息{name: text,...}
 */
grayConfigBiz.exportKeyTable = function (fields, search, success, fail) {
  const exportTable = new ExportTable({
    requestData: this.REQUEST_OPT.grayConfig.queryRuleDetail,
    fields: fields,
    search: search,
    isJson: 1
  })
  exportTable.send(success, fail)
}

export default grayConfigBiz
